export var UserContextErrorCodes;
(function (UserContextErrorCodes) {
    UserContextErrorCodes["FAILED_ME"] = "FAILED_ME";
    UserContextErrorCodes["FAILED_FEATURES"] = "FAILED_FEATURES";
    UserContextErrorCodes["INCORRECT_MODULE"] = "INCORRECT_MODULE";
    UserContextErrorCodes["INCORRECT_FEATURES"] = "INCORRECT_FEATURES";
    UserContextErrorCodes["INCORRECT_ROLE"] = "INCORRECT_ROLE";
})(UserContextErrorCodes || (UserContextErrorCodes = {}));
//# sourceMappingURL=UserContextErrorCodes.js.map